import { React, Component } from "react";
import "./Compose.css";
import { FaPaperPlane } from "react-icons/fa";
import { Add, Assignment, AttachFile, AutoAwesome, AutoFixHigh, AutoFixOff, Ballot, Check, CheckCircle, Menu as MenuIcon, OnlinePrediction, RecordVoiceOver, ShoppingBasket, ShoppingCart, ShoppingCartCheckout} from "@mui/icons-material";
import ToolTip from "@mui/material/Tooltip";
import Global from "../../customlib/Global";
import { Avatar, Box, Button, Divider, Grid, LinearProgress, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Menu, MenuItem, MenuList, Paper, Typography } from "@mui/material";
import axios from "axios";
import Api from "../../customlib/Api";

class Compose extends Component {
  state = {
    customerName: "",
    isMenuOpen: false,
    anchorEl: null,
    showSuggestion: false,
    suggestionList: [],
    isLoadingSuggestion: false,

  };

  handleOpenMenu = (event) => {
    this.setState({anchorEl: event.target, isMenuOpen: true});
  };

  handleCloseMenu = () => {
      this.setState({anchorEl: null, isMenuOpen: false});
  };

  onKeyDownHandler = (e) => {

    if(e.keyCode === 13 && e.ctrlKey){
        this.props.onSendMessage();
        console.log("CTRL + ENTER");
    }else if(e.keyCode === 13 && e.shiftKey){
        this.props.onSendMessage();
        console.log("CTRL + SHIFT");
    }else if (e.keyCode === 13) {
        console.log("ENTER");
    }
  };

  getStyleBtnCs = () => {
    let conversation = this.props.currentConversation;

    let btnDanger = "btn btn-warning";
    let btnOff = "btn btn-secondary";

    return conversation.csHelpState !== undefined && conversation.csHelpState !== "OFF" ? btnDanger : btnOff;

  }

  getStyleBtnLabel = () => {
    let conversation = this.props.currentConversation;

    let btnDanger = "btn btn-warning";
    let btnOff = "btn btn-secondary";

    return conversation.contactLabel !== undefined && conversation.contactLabel !== "" ? btnDanger : btnOff;

  }

  handleOnChange = (event) => {
    this.setState({ customerName: event.target.value });
  };

  componentDidMount() {
    console.log("CURRENT", this.props.currentConversation);
  }

  componentDidUpdate(){
    console.log("CURRENT", this.props.currentConversation);
  }

  ComponentSetLabel = () => {
    return (
      <ToolTip title="Label Customer">
        <button
          onClick={() => {
              console.log(Global.isCustomerService(), Global.isCustomerServiceSpv());
              if(Global.isCustomerService() || Global.isCustomerServiceSpv()){
                if(this.props.currentConversation.contactLabel !== undefined && this.props.currentConversation.contactLabel === Global.labelPaid()){
                  this.props.onSetContactLabelClick();
                }
              }else if(this.props.currentConversation.contactLabel === undefined || this.props.currentConversation.contactLabel === Global.labelBelumDiresponCustomer() || this.props.currentConversation.contactLabel === Global.labelLeadsPooling() || this.props.currentConversation.contactLabel === "" || this.props.currentConversation.contactLabel === Global.labelUnpaid() || this.props.currentConversation.contactLabel === Global.labelDp() || this.props.currentConversation.contactLabel === Global.labelCancel() || this.props.currentConversation.contactLabel === Global.labelPending()){
                console.log("CONVERSATION ELSE IF : ", this.props.currentConversation);
                // this.props.onCsHelpButtonClick();
                this.props.onSetContactLabelClick();
              }else if(Global.get().admin === true || Global.isAdminTeleUser() || Global.isTeleCutomer()){
                this.props.onSetContactLabelClick();
              }
              // this.props.onSetContactLabelClick();
              console.log(this.props.currentConversation)
              this.handleCloseMenu();
            }
          }
          className={this.getStyleBtnLabel()}
          style={{borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px", width: "100%"}}
          type="button"
          id="button-addon2"
        >
          {
            this.props.currentConversation.contactLabel === undefined  || this.props.currentConversation.contactLabel === "" ? 
            (
              <div><div className="badge badge-pill badge-dark">Set Label</div></div>
            ):
            (
              <div></div>
            )
          }

          {
            this.props.currentConversation.contactLabel !== undefined  && this.props.currentConversation.contactLabel !== "" ? 
            (
              <div><div className={Global.getLabelClasses(this.props.currentConversation.contactLabel)}>{this.props.currentConversation.contactLabel}</div></div>
            ):
            (
              <div></div>
            )
          }

        </button>
      </ToolTip>
    );
  }

  ComponentAttachment = () => {
    return (
      <ToolTip title="Attachment">
        <button
          onClick={() =>{
              this.props.onOpenDropZone();
              this.handleCloseMenu();
            }
          }
          className="btn btn-danger" 
          type="button"
          id="button-addon2"
          style={{width: "100%"}}
        >
          <AttachFile
            key="composesend"
            className="text-center"
            style={{ color: "#FFFFFF" }}
          />
          &nbsp;{this.props.isMobile && this.props.isMobile() === true ? "Attachment" : ""}
        </button>
      </ToolTip>
    );
  }

  ComponentHsm = () => {
    return (
      <ToolTip title="Pesan Template">
        <button
          onClick={() => {
            this.props.onTemplateButtonClick();
            this.handleCloseMenu();
          }
          }
          className="btn btn-warning"
          type="button"
          id="button-addon2"
          style={{width: "100%"}}
        >
          <Assignment
            key="sendtemplate"
            className="text-center"
            style={{ color: "#FFFFFF" }}
          />
          &nbsp;{this.props.isMobile && this.props.isMobile() === true ? "HSM" : ""}
        </button>
      </ToolTip>
    );
  }

  ComponentKirimOrder = () => {
    return (
      <ToolTip title="Kirim Form Order">
        <button
          onClick={() => {
            this.props.onSendFormOrderClick();
            this.handleCloseMenu();
            }
          }
          className="btn btn-success"
          type="button"
          id="button-flow-form"
          style={{width: "100%"}}
        >
          <ShoppingCart
            key="flow-cart-form-order"
            className="text-center"
            style={{ color: "#FFFFFF" }}
          />
          &nbsp;{this.props.isMobile && this.props.isMobile() === true ? "Kirim Order" : ""}
        </button>
      </ToolTip>
    );
  }

  ComponentKirimCatalogue = () => {
    return (
      <ToolTip title="Kirim Katalog">
        <button
          onClick={() => {
            this.props.onSendCatalogueClick();
            this.handleCloseMenu();
            }
          }
          className="btn btn-success"
          type="button"
          id="button-kirim-catalogue"
        >
          <Ballot
            key="kirim-catalogue"
            className="text-center"
            style={{ color: "#FFFFFF" }}
          />
          &nbsp;{this.props.isMobile && this.props.isMobile() === true ? "Kirim Katalog" : ""}
        </button>
      </ToolTip>
    );
  }

  toggleShowSuggestion = () => {
    this.setState({showSuggestion: !this.state.showSuggestion}, () => {
      if(this.state.showSuggestion === true){
        this.props.loadSuggestion();
      }
    });  
  }

  handleCloseSuggestion = () => {
    this.setState({showSuggestion: false});  
  }

  // aiAskSuggestion = () => {

  //   this.setState({isLoadingSuggestion: true}, () => {
  //     let params = {
  //                   values: {
  //                     contents: [
  //                       {
  //                         parts: [
  //                           {
  //                             text: "pelanggan berkata saya sudah pesan di tempat lain"
  //                           },
  //                           // {
  //                           //   "text": "berikan 4 saran jawaban dengan delimiter ## untuk customer tersebut, langsung jawabannya saja, tanpa reaksi"
  //                           // }
  //                         ]
  //                       }
  //                     ]
  //                   }
  //                 };
      
  //     axios
  //       .post(Api.aiAskSuggestion(), params, Api.getRequestHeader())
  //       .then((response) => {
  
  //         const responseData = response.data;

  //         responseData.data.forEach(item => {
  //           item.isSelected = false;
  //         });
          
  //         this.setState({suggestionList: responseData.data, isLoadingSuggestion: false});
          
  //       })
  //       .catch((error) => {
  //         this.setState({ errorMessage: error.message, isLoadingSuggestion: false });
  //         console.error("There was an error!", error);
  //       });
  //   });

  // }

  render() {

    // if(
    //   this.props.currentConversation.isTeleCustomer && ["OPEN", "SOLVING"].includes(this.props.currentConversation.csHelpState) && ["COMPLAINT", "Complaint"].includes(this.props.currentConversation.contactLabel?.toLowerCase()) 
    //   && !Global.get().admin && !Global.isCustomerService() && !Global.isCustomerServiceSpv()  
    // ){
    //   return (
    //     <Paper elevation={3} sx={{paddingTop: "20px", paddingBottom: "20px", textAlign: "center"}}>
    //       Customer ini sedang di tangani oleh CS
    //     </Paper>
    //   );
    // }

    // if(
    //   !this.props.currentConversation.isTeleCustomer && ["OPEN", "SOLVING"].includes(this.props.currentConversation.csHelpState) && ["COMPLAINT", "Complaint",Global.labelKonfirmasi(), Global.labelKonfirmasiPesanan()].includes(this.props.currentConversation.contactLabel) 
    //   && !Global.get().admin && !Global.isCustomerService() && !Global.isCustomerServiceSpv()  
    // ){
    //   return (
    //     <Paper elevation={3} sx={{paddingTop: "20px", paddingBottom: "20px", textAlign: "center"}}>
    //       Customer ini sedang di tangani oleh CS
    //     </Paper>
    //   );
    // }


    return (
      <Paper elevation={3}>
      <div className="compose">
        {/* {
          this.props.currentConversation.customerName === "" ? 
          (
            <div className="container" style={{marginBottom: "10px", position: "absolute", zIndex: 10000, bottom: "60px"}}>
              <div className="row">
                <div className="col-4"></div>
                <div className="col-4 border rounded bg-secondary" style={{padding: "10px", boxShadow: "5px 5px #DEDEDE"}}>
                  <div className="bg-light border rounded" style={{padding: "20px"}}>
                    <TextField
                      style={{marginBottom: "35px"}}
                      type="text"
                      onChange={this.handleOnChange}
                      className="form-control bg-light"
                      placeholder="Ketikkan nama customer disini"
                      label="Nama Customer"
                    />
                    <div className="btn btn-warning btn-block" onClick={() => this.props.onSaveCustomerName(this.state.customerName)}>Simpan Nama Cutomer</div>
                  </div>
                </div>
                <div className="col-4"></div>
              </div>
            </div>
          ) : 
          this.props.currentConversation.customerName === undefined || this.props.currentConversation.customerName === null ? (<></>) : (<></>)
          
        } */}
        
        <div
          className="input-group"
          style={{ marginLeft: "5px", marginTop: 0, marginRight: 15 }}
        >
            <div className="input-group-append">

            {
              this.props.isMobile && this.props.isMobile() !== true && 
              <this.ComponentSetLabel />
            }

            {
              this.props.isMobile && this.props.isMobile() !== true && 
              this.props.currentConversation.contactLabel !== undefined  && this.props.currentConversation.contactLabel === "DP" ? 
                (
                  <ToolTip title="Status bantuan CS">
                    <button
                      onClick={() => {

                          if(this.props.currentConversation.csHelpState === undefined || this.props.currentConversation.csHelpState === "OPEN" || this.props.currentConversation.csHelpState === "OFF"){
                            this.props.onCsHelpButtonClick();
                          }else{
                            if(Global.get().admin === true || Global.isCustomerServiceSpv()){
                              this.props.onCsHelpButtonClick();
                            }
                          }                      
                          console.log(this.props.currentConversation)
                        }
                      }
                      className={this.getStyleBtnCs()}
                      type="button"
                      id="button-addon2"
                    >

                      {
                        this.props.currentConversation.csHelpState !== undefined && this.props.currentConversation.csHelpState !== "OFF" ? 
                        (
                          <RecordVoiceOver
                            key="csHelp"
                            className="text-center"
                            style={{ color: "#FFFFFF" }}
                          />
                        ) : 
                        (
                          <RecordVoiceOver
                            key="csHelp"
                            className="text-center"
                            style={{ color: "#FFFFFF" }}
                          />
                        )
                      }

                      {
                        this.props.currentConversation.csHelpState === undefined | this.props.currentConversation.csHelpState === "OFF" ? 
                        (
                          <div><small>Oper ke  CS</small></div>
                        ):
                        (
                          <div></div>
                        )
                      }

                      {
                        this.props.currentConversation.csHelpState === "OPEN" ? 
                        (
                          <div><small>Menunggu CS</small></div>
                        ):
                        (
                          <div></div>
                        )
                      }

                      {
                        this.props.currentConversation.csHelpState === "SOLVING" ? 
                        (
                          <div><small>Sedang Diproses</small></div>
                        ):
                        (
                          <div></div>
                        )
                      }

                      {
                        this.props.currentConversation.csHelpState === "SOLVED" ? 
                        (
                          <div><small>CS Selesai</small></div>
                        ):
                        (
                          <div></div>
                        )
                      }

                    </button>
                  </ToolTip>
                ) : 
                (<></>)
            }
              {
                
              }
            
              {
                this.props.isMobile && this.props.isMobile() !== true && 
                <this.ComponentAttachment />
              }

              {
                this.props.isMobile && this.props.isMobile() !== true && 
                <this.ComponentHsm />
              }

              {
                this.props.isMobile && this.props.isMobile() !== true && 
                <this.ComponentKirimOrder />
              }

              {
                this.props.isMobile && this.props.isMobile() !== true && 
                <this.ComponentKirimCatalogue />
              }

              {
                this.props.isMobile && this.props.isMobile() === true && 
                <Button startIcon={<Add sx={{width: "35px", height: "35px"}} />} onClick={this.handleOpenMenu}></Button>
              }
              
              
            {/* { props.rightItems } */}
          </div>
          {/* <input
            onKeyDown={this.onKeyDownHandler}
            value={this.props.messageValue}
            onChange={this.props.onChange}
            type="text"
            className="form-control"
            placeholder="Type a message"
            aria-label="Type amessage"
            aria-describedby="button-addon2"
          /> */}
          <textarea
            onKeyDown={this.onKeyDownHandler}
            value={this.props.messageValue}
            onChange={this.props.onChange}
            type="text"
            className="form-control"
            placeholder="Ketikkan pesan anda di sini"
            aria-label="Ketikkan pesan anda di sini"
            aria-describedby="button-addon2"
          />
          <div className="input-group-append">
            <ToolTip title={"Suggestions"}>
              <button
                onClick={this.props.toggleShowSuggestion}
                className="btn btn-warning"
                type="button"
                id="button-addon2"
              >
                <AutoFixHigh
                  key="composesend"
                  className="text-center"
                  style={{ color: "#FFFFFF" }}
                />
                <br />
                {this.props.messageValue && this.props.messageValue.length > 0 ? (<small style={{fontSize: "10px"}}>{this.props.messageValue.trim().length}</small>) : ""}
              </button>
            </ToolTip>
            <button
              onClick={() =>
                // this.props.onSendMessage("halo", this.props.currentConversation)
                this.props.onSendMessage(null)
              }
              className="btn btn-primary"
              type="button"
              id="button-addon2"
            >
              <FaPaperPlane
                key="composesend"
                className="text-center"
                style={{ color: "#FFFFFF" }}
              />
              <br />
              {this.props.messageValue && this.props.messageValue.length > 0 ? (<small style={{fontSize: "10px"}}>{this.props.messageValue.trim().length}</small>) : ""}
            </button>
            {/* { props.rightItems } */}
          </div>
        </div>
      </div>

      <Menu 
        anchorEl={this.state.anchorEl}
        open={this.state.isMenuOpen}
        onClose={this.handleCloseMenu}
      >
        <MenuList>
          <MenuItem sx={{padding: 0, margin: 0}}>
              <this.ComponentSetLabel />
          </MenuItem>
          <MenuItem sx={{padding: 0, margin: 0}}>
              <this.ComponentAttachment />
          </MenuItem>
          <MenuItem sx={{padding: 0, margin: 0}}>
              <this.ComponentHsm />
          </MenuItem>
          <MenuItem sx={{padding: 0, margin: 0}}>
              <this.ComponentKirimCatalogue />
          </MenuItem>
          {/* <MenuItem sx={{padding: 0, margin: 0}}>
              <this.ComponentKirimOrder />
          </MenuItem> */}
        </MenuList>
      </Menu>

      {
        this.props.showSuggestions && (
          <Paper elevation={5} sx={{zIndex: 100000,position: "absolute", borderRadius: "30px", bottom: 70, right: "1vw", padding: "8px", backgroundColor: "#deecfd99", minWidth: "30vw", maxWidth: "30vw"}}>
            <Box sx={{fontWeight: "normal", fontSize: "13px", backgroundColor: "#8da2f6f7", padding: "15px", borderRadius: "30px", maxHeight: "80vh", overflowY: "auto"}} className='text-xs'>
            {/* <Box sx={{fontWeight: "normal", fontSize: "13px", backgroundColor: "#facf8ff5", padding: "10px", borderRadius: "5px"}} className='text-xs'> */}
              <Grid container spacing={1}>
                <Grid item xs={1} textAlign={"center"}>
                  <AutoAwesome />
                </Grid>
                <Grid item xs={10} textAlign={"center"}>
                  <Typography variant="h6">Suggestions</Typography>
                </Grid>
                <Grid item xs={1} textAlign={"center"}>
                  <AutoAwesome />
                </Grid>
              </Grid>
              
              <Divider sx={{mt: "10px"}} />
              {
                this.props.isLoadingSuggestion && (
                  <Box textAlign={"center"} sx={{color: "#FFFFFF"}}>
                    <LinearProgress sx={{mb: "10px"}} />
                    <OnlinePrediction /> <strong>Thinking, please wait...</strong><br />
                  </Box>
                )
              }

              {
                !this.props.isAiSuggestionActive && (
                  <Box textAlign={"center"} sx={{mt: "10px"}}>
                    <AutoFixOff color="error"/>
                    {/* <br /> */}
                    {/* <Typography variant="strong">Sedang Tidak Aktif</Typography> */}
                    <Box sx={{mt: "10px", color: "#a40303"}}>
                      Hanya aktif apabila pesan terakhir berasal dari customer
                    </Box>
                  </Box>
                )
              }

              <List sx={{ width: '100%' }}>
              {
                // ["Terima kasih atas informasinya. Kami siap membantu jika ada kebutuhan lain di masa mendatang.",
                //   "Baik, tidak masalah. Semoga pesanan Anda berjalan lancar. Silakan hubungi kami lagi jika berubah pikiran atau butuh sesuatu nanti.",
                //   "Tentu. Apakah ada hal lain yang bisa kami bantu saat ini?",
                //   "Oh, begitu. Jika ada yang bisa kami bantu di kemudian hari atau jika Anda ingin membandingkan penawaran, jangan ragu untuk menghubungi kami"]
                this.props.suggestionData?.suggestions?.map((item, index) => {
                  return (
                    <ListItemButton 
                      key={item.uuid} 
                      alignItems="flex-start" 
                      sx={{borderRadius: "10px"}} 
                      dense 
                      onClick={() => this.props.onSelectSuggestion(item)}
                      color={item.isSelected ? "primary" : ""}
                    >
                      <ListItemAvatar>
                        <Avatar alt={item.isSelected ? "✓" : (index+1) + ""} src="/1.jpg"  />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box>
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{ color: 'text.primary' }}
                            >
                              {
                                // item.isSelected ? <Box sx={{color: "#9e0404", fontWeight: "bold"}}>{item.text}</Box> : <Box sx={{color: "#666564"}}>{item.text}</Box>
                                item.isSelected ? <Box sx={{color: "#02047f", fontWeight: "bold"}}>{item.text}</Box> : <Box sx={{color: "#323233"}}>{item.text}</Box>
                              }
                            </Typography>
                            {/* {" — I'll be in your neighborhood doing errands this…"} */}
                          </Box>
                        }
                        // secondary={
                        //   <></>
                        // }
                      />
                    </ListItemButton>
                  );
                })
              }
              </List>
            </Box>
          </Paper>
        )
      }
      </Paper>
    );
  }
}

export default Compose;

// export default function Compose(props) {
//     return (
//       <div className="compose">
//           {/* <div className="row">
//             <div className="col-11"> */}
//                 {/* <input
//                     type="text"
//                     style={{width: "95%"}}
//                     //   className="compose-input"
//                     placeholder="Type a message"
//                     /> */}
//             <div className="input-group" style={{marginLeft: 10, marginTop: 0, marginRight: 15}}>
//                 <input value={props.messageValue} onChange={props.onChange} type="text" className="form-control" placeholder="Type a message" aria-label="Type amessage" aria-describedby="button-addon2" />
//                 <div className="input-group-append">
//                     <button onClick={() => props.onSendMessage("halo", props.currentConversation)} className="btn btn-primary" type="button" id="button-addon2">
//                         <FaPaperPlane key="composesend" className="text-center" style={{color: "#FFFFFF"}} />
//                     </button>
//                     {/* { props.rightItems } */}

//                 </div>
//             </div>
//             {/* </div>
//             <div className="col-1"> */}
//                 {/* { props.rightItems } */}
//             {/* </div> */}
//           {/* </div> */}
//       </div>
//     );
// }
